"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Sat Nov 03 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of GridSettings
 * @author RV
 */


var GridSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(GridSettingsConverter, _DataObjectConverter_);

  function GridSettingsConverter() {
    _classCallCheck(this, GridSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridSettingsConverter).apply(this, arguments));
  }

  return GridSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.GridSettingsConverter = GridSettingsConverter;